import { action } from "satcheljs";

const refreshConflictsInView = action(
    "REFRESH_CONFLICTS_IN_VIEW", () => ({ })
);

export default refreshConflictsInView;